/**
 * Auth API calls — CR-0030.
 * Calls the backend proxy endpoints (NOT the external API directly).
 */
import http from "@/api/client";

export async function loginApi(email, password) {
  const { data } = await http.post("/auth/login", { email, password });
  return data;
}

export async function logoutApi(token) {
  const { data } = await http.post("/auth/logout", "", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
